import { ColorType } from "../..";
import { Radius, Space } from "../LayoutProvider";
import { AHThemeType } from "./AHTheme";

export type SpaceProps = {
  space?: Space;
  spaceVertical?: Space;
  spaceHorizontal?: Space;
  spaceLeft?: Space;
  spaceRight?: Space;
  spaceTop?: Space;
  spaceBottom?: Space;
};

export type BoxProps = {
  width?: number /* is correctly scaled */;
  height?: number /* is correctly scaled */;
  color?: ColorType;
  cornerRadius?: Radius;
  cornerRadiusTopLeft?: Radius;
  cornerRadiusTopRight?: Radius;
  cornerRadiusBottomLeft?: Radius;
  cornerRadiusBottomRight?: Radius;
  borderColor?: ColorType;
  shadow?: keyof AHThemeType["shadow"];
  shadowTint?: ColorType;
  insets?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  gap?: Space;
  testID?: string;
} & SpaceProps;
